"use client";

import { useEffect } from "react";

import { reportError } from "@/lib/logger";

import "./globals.css";

// Replaces the root layout when it throws, so it renders its own <html>/<body>.
// The i18n provider lives in that layout, so this page shows both languages
// (eslint jsx-no-literals exception, docs/specs/foundation/i18n.md).
/* eslint-disable react/jsx-no-literals */
export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    reportError(error, { digest: error.digest });
  }, [error]);

  return (
    <html lang="id-ID">
      <body className="grid min-h-dvh place-items-center bg-background p-4 text-center text-foreground">
        <main role="alert" className="flex flex-col items-center gap-3">
          <h1 className="text-lg font-semibold">Terjadi kesalahan · Something went wrong</h1>
          {error.digest && (
            <p className="text-xs text-muted-foreground">Referensi · Reference: {error.digest}</p>
          )}
          <button
            type="button"
            onClick={() => retry()}
            className="rounded-md bg-primary px-4 py-2 text-sm text-primary-foreground"
          >
            Coba lagi · Try again
          </button>
        </main>
      </body>
    </html>
  );
}
